<!-- Copyright 2018 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
      <div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
        <mat-toolbar color="primary" class="example-toolbar">
          <button mat-icon-button (click)="snav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
          <h1 class="example-app-name" style="cursor: pointer;" class="nav-link"  [routerLink]="'/prestacion'">Avanflow</h1>
          <span class="example-spacer"></span>
          <div><span style="font-size: 10px; margin-right: 20px; vertical-align: sub;">v{{version}}</span></div>
          <button routerLink="/login"  mat-icon-button><mat-icon>exit_to_app</mat-icon></button>
        </mat-toolbar>

        <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
          <mat-sidenav #snav  [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">


            <mat-expansion-panel expanded="true">

              <mat-expansion-panel-header>
                <mat-panel-title >
                  Cuenta
                </mat-panel-title>
                <mat-panel-description ></mat-panel-description>
              </mat-expansion-panel-header>
              <div style="display: flex; margin:auto; align-content: center; text-align: center">

                <div >
                  <mat-icon>account_circle</mat-icon>
                </div>
                <div style="flex: 1">
                  <div style="flex:1">
                    <a mat-list-item style="font-weight: bold;">
                     {{user?.firstName}} {{user?.lastName}}
                    </a>

                    <div style="font-size: 0.7rem">
                      {{user?.email}}
                    </div>
                    <div style="opacity: 0.7; font-size: 0.6rem;">
                      {{user?.profile.description}}
                    </div>
                  </div>

                  <div style="flex:1">
                    <a mat-list-item>

                    </a>
                  </div>
                </div>
              </div>
              <mat-divider style="width: 90%;"></mat-divider>
              <mat-selection-list [multiple]="false">
                <mat-list-option mat-list-item class="nav-link" [routerLink]="'/cambiar-password'">
                  <div class="grid-nav" style="font-size: 0.8rem;">
                    <i class="material-icons md-18 md-dark md-inactive grid-nav-icon">vpn_key</i>
                    <span class="gird-nav-text">Cambiar contraseña</span>
                  </div>
                 <!-- <div>
                  <i class="material-icons md-18 md-dark md-inactive" >vpn_key</i>
                  Modificar contraseña
                 </div> -->
                </mat-list-option>
              </mat-selection-list>

            </mat-expansion-panel>


            <mat-selection-list [multiple]="false">
              <mat-list-option *ngFor="let modulo of modulos" (click)="cerrarSideNav()" class="nav-link" (click)="nav(modulo)">
                <div class="grid-nav">
                  <i class="material-icons md-18 md-dark md-inactive grid-nav-icon">{{modulo.icono}}</i>
                  <span class="gird-nav-text">{{modulo.nombre}}</span>
                </div>
                <mat-divider style="width: 90%;"></mat-divider>
              </mat-list-option>
            </mat-selection-list>



          </mat-sidenav>
          <br>
          <!--Aca están todos los módulos-->
          <div class="wrapp-main">
            <router-outlet></router-outlet>
          </div>
          <!--Aca están todos los módulos-->
        </mat-sidenav-container>
      </div>
